import { render } from "./CardTestimonials.vue?vue&type=template&id=50ec7c70"
import script from "./CardTestimonials.vue?vue&type=script&lang=js"
export * from "./CardTestimonials.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/victoriya-date.elena-dating.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__